// https://www.davedrinks.coffee/how-do-i-use-two-react-refs/
export default function mergeRefs(...refs: React.Ref<any>[]) {
    const filteredRefs = refs.filter(Boolean);
    if (!filteredRefs.length) return null;
    if (filteredRefs.length === 1) return filteredRefs[0];

    return (output: React.Ref<any>) => {
        for (const ref of filteredRefs) {
            if (typeof ref === 'function') {
                ref(output);
            } else if (ref) {
                (ref as any).current = output;
            }
        }
    };
}
